import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import TextFieldTsoPq from '@components/TextField/TextFieldTsoPq';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type SearchFieldTsoPqProps = {
  searchKey: 'label' | 'id';
  searchQuery: string;
  handleChange: React.Dispatch<React.SetStateAction<string>>;
  resetSearch: React.Dispatch<React.SetStateAction<string[]>>;
  customwidth?: string;
  customLabel?: string;
};

const StyledTextFieldTsoPq = styled(TextFieldTsoPq)(() => {
  return {
    '& .MuiInputBase-root': {
      height: '2.125rem',

      '&:hover': {
        background: tsoPqTheme.palette.background.neutral.color_neutral_background_bg_neutral_lt,
      },

      '&.Mui-focused': {
        background: tsoPqTheme.palette.background.primary.color_primary_background_bg_prim_enabled_lt,
      },

      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: tsoPqTheme.palette.stroke.color_neutral_stroke_str_ntrl_hover,
      },

      '& .MuiInputBase-input': {
        color: tsoPqTheme.palette.customTextColor.color_neutral_font_ft_nrtrl_enabled,
        '& .MuiOutlinedInput-input': {
          fontFamily: tsoPqTheme.typography.openSans,
          fontSize: tsoPqTheme.typography.fontsize_body_body_small,
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '0.875rem',
        },
      },
    },
  };
});

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)(() => {
  return {
    color: tsoPqTheme.palette.customTextColor.color_neutral_font_ft_nrtrl_enabled,
    padding: tsoPqTheme.spacingValues.componentSpacing.spacing_component_padding_4,
    height: '1.125rem',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
  };
});

const SearchFieldTsoPq = ({
  searchKey,
  searchQuery,
  handleChange,
  resetSearch,
  customwidth,
  customLabel,
}: SearchFieldTsoPqProps) => {
  const [searchLabel, setSearchLabel] = useState<string>('label');

  const { t } = useTranslation();

  useEffect(() => {
    customLabel ? setSearchLabel(customLabel) : setSearchLabel(`${t('searchfield.placeholder')}`);
  }, [searchKey]);

  return (
    <StyledTextFieldTsoPq
      customwidth={customwidth}
      value={searchQuery}
      handleChange={handleChange}
      placeholder={searchLabel}
      iconLeft={<StyledFontAwesomeIcon icon={faMagnifyingGlass} />}
      clearInput={searchQuery.length > 0}
      resetSearch={resetSearch}
    />
  );
};

export default SearchFieldTsoPq;
